// extracted by mini-css-extract-plugin
export default {"loading_page":"loading_page_loading_page__5eQTb"};